var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.5 17.1a5.4 5.4 0 105.4 5.4 5.4 5.4 0 00-5.4-5.4zm12.5-4a5.4 5.4 0 00-3-3.1c-2.1-.9-7.2-.7-9.5-.7s-7.4-.2-9.5.7a5.4 5.4 0 00-3 3c-.9 2.1-.7 7.2-.7 9.5s-.2 7.4.7 9.5a5.4 5.4 0 003 3c2.1.9 7.2.7 9.5.7s7.4.2 9.5-.7a5.4 5.4 0 003-3c.9-2.1.7-7.2.7-9.5s.2-7.4-.7-9.5zM22.5 30.6a8.2 8.2 0 115.8-2.4 8.2 8.2 0 01-5.8 2.4zm8.6-14.9a2 2 0 111.3-.5 2 2 0 01-1.3.5zM40 0H4.9A4.8 4.8 0 000 4.8v35.4A4.8 4.8 0 004.8 45h35.4a4.8 4.8 0 004.8-4.8V4.8A4.8 4.8 0 0040.2 0zm-1.6 29.1a9.6 9.6 0 01-2.6 6.8 9.6 9.6 0 01-6.8 2.6H16A9.6 9.6 0 019 35.9 9.5 9.5 0 016.5 29V16A9.5 9.5 0 019.1 9 9.6 9.6 0 0116 6.5H29A9.6 9.6 0 0136 9.1a9.6 9.6 0 012.6 6.8V29z","fill":"#fff"}));
}

Instagram.defaultProps = {"viewBox":"0 0 45 45"};

module.exports = Instagram;

Instagram.default = Instagram;
